import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilyMono,
  fontWeight: 700,
  fontSize: '2.25rem',
  textAlign: 'center',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '1.75rem',
  },
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '1.125rem',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(8),
  maxWidth: 560,
  marginLeft: 'auto',
  marginRight: 'auto',
  lineHeight: 1.6,
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(6),
  },
}));
